export const selectTheme = state => state.theme;

export const selectThemeValue = state => state.theme.theme;
